"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalDeviceStatus = exports.PaymentTerminalPaymentStatus = exports.TerminalIntegrationType = void 0;
var TerminalIntegrationType;
(function (TerminalIntegrationType) {
    TerminalIntegrationType[TerminalIntegrationType["Adyen"] = 0] = "Adyen";
    TerminalIntegrationType[TerminalIntegrationType["Nets"] = 1] = "Nets";
    TerminalIntegrationType[TerminalIntegrationType["Surfboard"] = 2] = "Surfboard";
    TerminalIntegrationType[TerminalIntegrationType["AdyenTapToPay"] = 3] = "AdyenTapToPay";
    TerminalIntegrationType[TerminalIntegrationType["Simulated"] = 4] = "Simulated";
})(TerminalIntegrationType = exports.TerminalIntegrationType || (exports.TerminalIntegrationType = {}));
var PaymentTerminalPaymentStatus;
(function (PaymentTerminalPaymentStatus) {
    /** Custom (client-side) */
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["WaitingForTerminal"] = -100] = "WaitingForTerminal";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["Started"] = 0] = "Started";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["AwaitTip"] = 1] = "AwaitTip";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["TipEntered"] = 2] = "TipEntered";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["AwaitingCard"] = 3] = "AwaitingCard";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["CardPresented"] = 4] = "CardPresented";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["CardRemoved"] = 5] = "CardRemoved";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["AwaitingPin"] = 10] = "AwaitingPin";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["PinEntered"] = 12] = "PinEntered";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["WrongPin"] = 13] = "WrongPin";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["Finalizing"] = 14] = "Finalizing";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["Declined"] = 17] = "Declined";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["Cancelled"] = 18] = "Cancelled";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["Error"] = 19] = "Error";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["Refunded"] = 20] = "Refunded";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["PartiallyRefunded"] = 21] = "PartiallyRefunded";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["TransactionVerification"] = 24] = "TransactionVerification";
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["Approved"] = 25] = "Approved";
    /** Last state of the transaction */
    PaymentTerminalPaymentStatus[PaymentTerminalPaymentStatus["Finalized"] = 100] = "Finalized";
})(PaymentTerminalPaymentStatus = exports.PaymentTerminalPaymentStatus || (exports.PaymentTerminalPaymentStatus = {}));
var TerminalDeviceStatus;
(function (TerminalDeviceStatus) {
    TerminalDeviceStatus[TerminalDeviceStatus["Shutdown"] = 0] = "Shutdown";
    TerminalDeviceStatus[TerminalDeviceStatus["Maintenance"] = 1] = "Maintenance";
    TerminalDeviceStatus[TerminalDeviceStatus["OutOfOrder"] = 2] = "OutOfOrder";
})(TerminalDeviceStatus = exports.TerminalDeviceStatus || (exports.TerminalDeviceStatus = {}));
